// extracted by mini-css-extract-plugin
export default {"filtersBtn":"styles_filtersBtn__rG5tp"};